import React from 'react';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { StaffEntitySearchContainerEntitySearchFacetsFieldsFragment } from '../../../../generated';
import { CheckFilterInterface, EntitySearchFilter } from './entity-search-filter';
import { useQuery } from '@apollo/client';
import { lookupCountryQuery } from './staff-components-country-query';
import { Country } from '../../../../types/country';

interface EntitySearchFilterContainerProps {
  setFilters: React.Dispatch<React.SetStateAction<CheckFilterInterface>>;
  filterDataCount: StaffEntitySearchContainerEntitySearchFacetsFieldsFragment;
}

export const EntitySearchFilterContainer: React.FC<EntitySearchFilterContainerProps> = (props) => {
  const {
    data: countryData,
    loading: countryListLoading,
    error: countryListError
  } = useQuery(lookupCountryQuery, {
    context: { clientName: 'unauthorized' }
  });

  return (
    <div className="min-w-[220px] max-w-[300px]">
      <ComponentQueryLoader
        loading={countryListLoading}
        hasData={countryData}
        error={countryListError}
        hasDataComponent={
          <EntitySearchFilter countryData={countryData?.countries?.eventPayload?.countries as Country[]} setFilters={props?.setFilters} data={props?.filterDataCount} />
        }
      />
    </div>

  );
};
